import React from "react";
import { Modal } from "flowbite-react";
import { Button } from "../buttons";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ModalNotPermission = ({ openModal, setOpenModal }) => {
  return (
    <Modal show={openModal} onClose={() => setOpenModal(false)} size="sm" theme={tenkenTheme.modal_help}>
    <Modal.Body>権限がありません</Modal.Body>
    <Modal.Footer>
      <Button
        color="reset"
        className="min-w-[120px] h-9"
        children="閉じる"
        onClick={() => setOpenModal(false)}
      />
    </Modal.Footer>
  </Modal>
  );
};

export default ModalNotPermission;
